<template>
  <transition name="move-up" @enter="handleEnter" @leave="handleLeave" appear>
    <div class="k-message-notice">
      <div class="k-message-notice-content">
        <k-icon :type="iconName" size="16" color="#666"></k-icon>
        <div
          class="k-message-notice-content-text"
          :class="classes"
          v-html="content"
        ></div>
        <k-icon
          v-if="closable"
          @click="close"
          type="close"
          color="#999"
          size="16"
        ></k-icon>
      </div>
    </div>
  </transition>
</template>

<script>
const iconTypes = {
  info: "info-circle-fill",
  success: "check-circle-fill",
  warning: "warning-circle-fill",
  error: "close-circle-fill"
  // loading: "ios-loading"
};
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    type: {
      validator(val) {
        return ["info", "success", "warning", "error"].includes(val);
      },
      default: "info"
    },
    duration: {
      type: Number,
      default: 1.5
    },
    content: { type: String, default: "" },
    closable: { type: Boolean, default: false },
    onClose: { type: Function }
  },
  computed: {
    classes() {
      return [{ [`with-close`]: this.closable }];
    },
    iconName() {
      return iconTypes[this.type];
    }
  },
  data() {
    return {};
  },
  methods: {
    close() {
      if (this.closable) {
        this.onClose();
      }
      this.$parent.close(this.name);
    },
    clearCloseTimer() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    },
    handleEnter(el) {
      el.style.height = el.scrollHeight + "px";
    },
    handleLeave(el) {
      if (document.getElementsByClassName("k-message-notice").length !== 1) {
        el.style.height = 0;
        el.style.paddingTop = 0;
        el.style.paddingBottom = 0;
      }
    }
  },
  mounted() {
    this.clearCloseTimer();
    if (this.duration !== 0) {
      this.closeTimer = setTimeout(() => {
        this.close();
      }, this.duration * 1000);
    }
  },
  beforeDestroy() {
    this.clearCloseTimer();
  }
};
</script>
